import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';
import { MENU_COLLAPSE_BREAKPOINT } from '../SingleToolNavigation';

export default createUseStyles(({ breakpoints }: ITheme) => ({
  root: {
    backgroundColor: 'var(--x-bg-5)',
  },
  main: {},
  mainContainer: {
    padding: [0, 40, 24, 40],

    [mediaQuery(breakpoints.tablet)]: {
      padding: [0, 0, 24, 0],
    },
  },
  mainContent: {
    display: 'flex',
  },
  mainContentSidebar: {
    flex: '205px 0 0',
    paddingTop: 32,

    [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
      display: 'none',
    },
  },
  mainContentResults: {
    flex: 1,
    minWidth: 0,
    position: 'relative',
  },
  mainContentBar: {
    padding: [12, 0, 14, 0],
    position: 'sticky',
    backgroundColor: 'var(--x-bg-5)',
    zIndex: 10,

    // top: ({ stickyInputConainerH, stickyInputTextH }) => {
    //   const res =
    //     HEADER_HEIGHT + (stickyInputConainerH - stickyInputTextH - CMP_PADDING);
    //   console.log('normal');

    //   return res;
    // },

    // [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
    //   top: ({ stickyInputConainerH, stickyInputTextH }) => {
    //     const res =
    //       MOBILE_HEADER_HEIGHT +
    //       (stickyInputConainerH - stickyInputTextH - CMP_PADDING);

    //     return res;
    //   },
    // },
  },
  mainContentBarContent: {
    minHeight: 36,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: 16,
  },
  mainContentSidebarSticky: {
    position: 'sticky',
    top: 238,
    marginBottom: 32,

    [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
      top: 197,
    },
  },
  landing: {
    background: '#ffffff',
    paddingTop: 90,
  },
}));
